<u-textarea-interactive
  ngDefaultControl
  name="uTextareaInteractive"
  [footerTemplate]="footerView() ? footerTemplate : null"
  [rightSideTemplate]="footerView() ? savePositionTemplate : rightSideTemplate"
  [leftSideTemplate]="footerView() ? savePositionTemplate : leftSideTemplate"
  [placeholder]="(assistantData()?.knowledgeType !== 'External' ? TEXTAREA_PLACEHOLDER : 'Message') + ' ' + (assistantData()?.name || '')"
  [rows]="isExtension ? 2 : 1"
  [cols]="30"
  [autoResize]="true"
  [maxRowLimit]="5"
  [minHeight]="isExtension ? 48 : 24"
  [maxWords]="MAX_INPUT_WORDS"
  [displayLimitWarning]="true"
  (onChange)="onQueryChange($event)"
  (onEnter)="handleSendQuery()"
  (handleValidationResult)="handleInputError($event)"
></u-textarea-interactive>

<ng-template #footerTemplate>
  <ng-container [ngTemplateOutlet]="leftSideTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="filesTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="rightSideTemplate"></ng-container>
</ng-template>

<ng-template #rightSideTemplate>
  <u-button
    class="inline-extra-icon"
    [versionNumber]="2"
    [fontIcon]="settingIcon().value"
    [typeElement]="settingIcon().typeElement"
    [styleType]="settingIcon().styleType"
    [sizeElement]="isExtension ? 'small' : 'medium'"
    [stateElement]="sendIconDisabled() ? 'disabled' : 'regular'"
    [styles]="settingIcon().styles"
    [iconStyles]="settingIcon().iconStyles"
    (onClick)="handleSendQuery()"
    [pTooltip]="settingIconTooltip()"
    tooltipPosition="left"
    tooltipStyleClass="u-tooltip"
  >
  </u-button>
</ng-template>

<ng-template #leftSideTemplate>
  @if (assistantData()?.knowledgeType === 'External') {
    @if (allowFileUpload()) {
      <ng-container [ngTemplateOutlet]="uploadFileTemplate"></ng-container>
    }
  } @else {
    <chat-filters-box
      [disabled]="messageInprogress()"
      [currentAssistant]="assistantData()?.id"
      (filterChange)="onFilterChanged()"
    ></chat-filters-box>
  }
</ng-template>

<ng-template #savePositionTemplate>
  @if (!isExtension) {
    <div class="save-position"></div>
  }
</ng-template>

<ng-template #uploadFileTemplate>
  <u-file-upload
    class="file-upload"
    fileIcon="pi pi-paperclip"
    [onlyIcon]="true"
    [multiple]="true"
    [accept]="acceptFiles()"
    [errorFileTypeMsg]="FILE_TYPE_NOT_SUPPORTED_ERROR"
    [maxFileSize]="chatFileService.MAX_FILE_SIZE_BYTES"
    [showErrorMessage]="false"
    [disabled]="maxFileUploaded() || !initCompleted()"
    (onSelect)="onUploadFiles($event)"
    (onError)="onUploadError($event)"
    [pTooltip]="fileUploadTooltip()"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
  ></u-file-upload>
</ng-template>

<ng-template #filesTemplate>
  <div class="files-container">
    @for (file of uploadedFile(); track $index) {
      <chat-file [file]="file" [viewMode]="'edit'" (removeFile)="removeFile.emit($event)"></chat-file>
    }
  </div>
</ng-template>
